import { createStore, applyMiddleware } from 'redux';
import _mapValues from 'lodash/mapValues';
import reducers from '../../reducers';
import firebaseMiddleware from '../../middlewares/firebaseMiddleware';
import chatSdkMiddleware from '../../middlewares/chatSdkMiddleware';
import thunk from 'redux-thunk';
import serverApi, { ServerApi } from '../serverApi';
import { initVisitCount, VisitCount } from '../visitCount';
import { i18n } from 'i18next';

function deserializeExperiments(experiments) {
  return _mapValues(experiments, value =>
    value === 'true' ? true : value === 'false' ? false : value,
  );
}

export interface ThunkExtraArgument {
  visitCount: VisitCount;
  serverApi: ServerApi;
}

export interface ConfigureStoreParams {
  experiments?: { [key: string]: string };
  initialState?: { [key: string]: any };
  i18nData?: i18n;
}

export default function configureStore({
  experiments,
  initialState,
  i18nData,
}: ConfigureStoreParams = {}) {
  const visitCount = initVisitCount();
  const middlewares = [
    thunk.withExtraArgument<ThunkExtraArgument>({ visitCount, serverApi }),
    firebaseMiddleware,
    chatSdkMiddleware,
  ];

  const newInitialState = {
    ...initialState,
    i18nData,
    experimentsRaw: { ...experiments },
    experiments: deserializeExperiments(experiments),
  };

  return createStore(
    reducers,
    newInitialState,
    applyMiddleware(...middlewares),
  );
}
